/**
 * 门店营收单组件独立访问页 V2（截图专用隔离入口）。
 * 与旧 /component 路由并行，避免互相影响。
 */
import React from "react";
import StoreRevenueComponentPage from "./ComponentPage";

const StoreRevenueComponentPageV2: React.FC = () => {
  return <StoreRevenueComponentPage />;
};

export default StoreRevenueComponentPageV2;
